import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSalesReport } from "../../../Utility/Api";
import { NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";

const DailysalesReportDetails = ({ date, handleSetpage }) => {
  console.log("date", date);
  const location = useLocation();
  const { state } = location;
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [DailySalesReport, setDailySalesReport] = useState();

  useEffect(() => {
    if (date) {
      handleView(date);
    }
  }, []);

  const handleView = async (date) => {
    try {
      showLoader();
      var filter = `from_date=${date}&to_date=${date}&shop_id=${shop_id}`;
      const response = await getSalesReport(filter);
      if (response.data && response.data.data) {
        setDailySalesReport(response.data.data);
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      console.error("Error fetching order data:", error);
    }
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <button
            className="btn py-1 btn-secondary text-small float-end"
            onClick={() => {
              handleSetpage();
            }}
          >
            {" "}
            X{" "}
          </button>
          {Array.isArray(DailySalesReport) && DailySalesReport.length > 0 && (
            <div className="container mt-4">
              <h2 className="text-center mb-4">Daily Sales Report - {date}</h2>

              <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th>Master ID/User</th>
                      <th>Customer Name</th>
                      <th>Sales (RO)</th>
                      <th>Unpaid on Sales (RO)</th>
                      <th>Price (INR)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {DailySalesReport &&
                      DailySalesReport.map((item) => (
                        <tr>
                          <td>{item.unique_id}</td>
                          <td>{item.customer_name}</td>
                          <td>{item.total}</td>
                          <td>{item.remaining}</td>
                          <td>{(item.total - item.remaining).toFixed()}</td>
                        </tr>
                      ))}
                    <tr className="table-primary fw-bold">
                      <td colSpan={2} className="text-end">
                        Total
                      </td>
                      <td colSpan={1} className="text-end">
                        RO{" "}
                        {DailySalesReport.reduce(
                          (acc, item) => acc + parseFloat(item.total || 0),
                          0
                        ).toFixed(3)}
                      </td>
                      <td>
                        RO{" "}
                        {DailySalesReport.reduce(
                          (acc, item) => acc + parseFloat(item.remaining || 0),
                          0
                        ).toFixed(3)}
                      </td>
                      <td colSpan={1}>
                        RO{" "}
                        {(
                          DailySalesReport.reduce(
                            (acc, item) => acc + parseFloat(item.total || 0),
                            0
                          ) -
                          DailySalesReport.reduce(
                            (acc, item) =>
                              acc + parseFloat(item.remaining || 0),
                            0
                          )
                        ).toFixed(3)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DailysalesReportDetails;
